<div fxFles [formGroup]="generateImage" fxLayout="column" fxLayoutGap="10px" style="overflow: hidden; padding-top: 10px">
  <div fxLayout="column" fxLayoutGap="5px" fxLayout.gt-md="row">
    <mat-form-field fxFlex>
      <mat-label>{{ 'labels.generate-image' | translate }}</mat-label>
      <input test-id="generate-images-input" matInput formControlName="generateText" (keyup.enter)="onGenerateImages()" />
    </mat-form-field>
    <button test-id="generate-images-button" mat-raised-button (click)="onGenerateImages()">
      {{ 'buttons.generate-image' | translate }}
    </button>
  </div>
  @if (generateImage.controls.imageUrl.value) {
    <div
      fxLayout="column"
      fxLayoutAlign="center center"
      style="cursor: pointer"
      [ngClass]="{
        'image-selected': imageUrl.value == generateImage.controls.imageUrl.value,
        'image-not-selected': imageUrl.value != generateImage.controls.imageUrl.value,
      }"
      (click)="onSelectImage()"
    >
      <img
        test-id="image-search-result"
        style="object-fit: contain; width: 100%; aspect-ratio: 1/1"
        [src]="generateImage.controls.imageUrl.value"
        [alt]="'Image url:' + generateImage.controls.imageUrl.value"
      />
    </div>
  }
</div>
